import selectors from './selectors'

export const mapSelectorsToProps = observableKeys => () => {
    // iterate through observable keys and
    // map those to stateSelectors variable
    let stateSelectors = {}
    observableKeys.forEach(key => {
        if (typeof selectors[key] == 'function') {
            stateSelectors[key] = selectors[key]()
        } else {
            throw new Error(`observables was passed key ${key} which was ` + `not a function (or undefined).`)
        }
    })

    // return the memoized state while considering
    // state & props
    return (state, props) => {
        let stateValues = {}
        Object.keys(stateSelectors).forEach(key => {
            stateValues[key] = stateSelectors[key](state, props)
        })

        return stateValues
    }
}

export default mapSelectorsToProps
